type RemoveMilestoneError = {
  notFound: boolean;
};

const removeMilestoneError: RemoveMilestoneError = {
  notFound: false,
};

export type { RemoveMilestoneError };

export { removeMilestoneError };
